<template lang="">
  <div class="py-10 bg-slate-300 inset-x-0 bottom-0 flex flex-col lg:flex-row text-small-size justify-between items-start font-basic">
    <img class="lg:px-32 w-[40%] lg:w-auto ml-4 lg:ml-0" src="@/assets/ic_leadwalk_logl.png" alt="">
    <div class="px-10 lg:px-0 flex flex-col justify-between text-small-size lg:text-[18px] text-text-0">
      <p class="">회사명: (주)리드워크</p>
      <p class="">주소: 서울 금천구 디지털로 178 가산 퍼블릭 B동 10층 1014호</p>
      <p class="">사업자 등록번호: 704-81-01605</p>
      <p class="">대표자: 이재문</p>
    </div>
    <div class="px-10 lg:px-0 flex flex-col lg:h-[120px] justify-between text-small-size lg:text-[18px] text-text-0 mt-5 lg:mt-0">
      <p class="">Email: contact@l-walk.com</p>
      <p class="">Fax: 070-4099-2401</p>
      <p class="">Tel: 02-6953-8506</p>
    </div>
    <div class="px-10 lg:px-0 flex flex-col lg:h-[120px] justify-between text-small-size lg:text-[18px] text-text-0 mt-5 lg:mt-0">
      <p class="cursor-pointer" @click="goToPage('/terms') ">이용 약관</p>
      <p class="cursor-pointer" @click="goToPage('/terms') ">개인정보처리방침</p>
      <p>Copyright 2023 All rights reserved - l-walk (주)리드워크</p>
    </div>
    <div class="lg:self-end mt-5 lg:mt-0">
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goToPage(path) {
      this.$router.push(path)
    }    
  }  
}
</script>